import {Button, CircularProgress} from '@mui/material';
import serviceBell from 'presentation/assets/images/service-bell.svg';
import React, {Fragment} from 'react';
import {translations} from 'presentation/translations-new';
import {useConcierge} from 'presentation/pages/private/my-hospitalization/hooks/useConcierge';
import {AlertModal, IFrameModal} from 'presentation/components';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {
	StyledButtonMobile,
	StyledContainer,
	StyledContainerText,
	StyledContentMobile,
	StyledDescription,
	StyledImageContainer,
	StyledTitle,
} from './styles';
import {usePatientData} from '../../../PatientData/hooks/usePatientData';

const {access, serverError2, serverErrorTitle2, tryAgain, notice} = translations['pt-br'].commons;
const {title, description} =
	translations['pt-br'].privateFlow.myHospitalization.home.conciergeBanner;
const {pageTitle} = translations['pt-br'].privateFlow.myHospitalization;

export const ConciergeBanner = () => {
	const {isMobile} = useMediaQueries();
	const {data} = usePatientData();
	const {
		isError,
		isFetching,
		handleOpenUrl,
		handleCloseErrorModal,
		conciergeUrl,
		handleCloseIframe,
		openConciergeIframe,
		setOpenConciergeIframe,
	} = useConcierge();

	if (!data || !data.conciergeEnabled) {
		return null;
	}

	const renderBanner = () => {
		if (isMobile) {
			return (
				<StyledContainer>
					<StyledTitle>{title}</StyledTitle>
					<StyledContentMobile>
						<StyledContainerText>
							<StyledDescription variant="body2">{description}</StyledDescription>
							<StyledButtonMobile
								data-tag-id={AppointmentBookingEnum.CLICK_ACESSAR_CONCIERGE}
								onClick={handleOpenUrl}
								disabled={isFetching}
								endIcon={
									isFetching ? (
										<CircularProgress size={16} color="inherit" />
									) : null
								}>
								{access}
							</StyledButtonMobile>
						</StyledContainerText>
						<StyledImageContainer>
							<img src={serviceBell} alt="Mão tocando um sino" />
						</StyledImageContainer>
					</StyledContentMobile>
				</StyledContainer>
			);
		}

		return (
			<StyledContainer>
				<StyledImageContainer>
					<img src={serviceBell} alt="Mão tocando um sino" />
				</StyledImageContainer>
				<StyledContainerText>
					<StyledTitle>{title}</StyledTitle>
					<StyledDescription variant="body2">{description}</StyledDescription>
				</StyledContainerText>
				<Button
					data-tag-id={AppointmentBookingEnum.CLICK_ACESSAR_CONCIERGE}
					onClick={handleOpenUrl}
					disabled={isFetching}
					endIcon={isFetching ? <CircularProgress size={16} color="inherit" /> : null}>
					{access}
				</Button>
			</StyledContainer>
		);
	};

	return (
		<Fragment>
			{renderBanner()}
			{isError ? (
				<AlertModal
					open={isError}
					onClose={handleCloseErrorModal}
					description={serverError2}
					title={serverErrorTitle2}
					headerTitle={notice}
					variant="info"
					footerContent={
						<Button
							variant="contained"
							size="large"
							fullWidth
							onClick={() => {
								handleCloseErrorModal();
								handleOpenUrl();
							}}>
							{tryAgain}
						</Button>
					}
				/>
			) : null}
			{conciergeUrl ? (
				<IFrameModal
					openIframe={openConciergeIframe}
					setOpenIframe={setOpenConciergeIframe}
					title={pageTitle}
					url={conciergeUrl}
					handleBack={handleCloseIframe}
				/>
			) : null}
		</Fragment>
	);
};
